(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.global-dc-network__tab');
  var arrows = document.querySelectorAll('.global-dc-network__arrow');
  var markers = document.querySelectorAll('.global-dc-network__map .marker');
  var index = 0;
  var svgContent = document.getElementById('svg-content');
  var mapRoot = document.getElementById('map-root');
  if (!tabs.length) {
    return;
  }
  if (svgContent && mapRoot) {
    while (svgContent.firstChild) {
      mapRoot.appendChild(svgContent.firstChild);
    }
  }
  var setActive = function setActive(i) {
    tabs.forEach(function (t) {
      return t.classList.remove('active');
    });
    tabs[i].classList.add('active');
    var activeMarker = tabs[i].dataset.marker;
    markers.forEach(function (m) {
      m.classList.toggle('active', m.dataset.marker === activeMarker);
    });
  };
  arrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      var dir = arrow.dataset.dir;
      if (dir === 'next') {
        index = (index + 1) % tabs.length;
      } else {
        index = (index - 1 + tabs.length) % tabs.length;
      }
      setActive(index);
    });
  });
  markers.forEach(function (marker) {
    marker.addEventListener('click', function () {
      var markerId = marker.dataset.marker;
      var targetIndex = Array.from(tabs).findIndex(function (t) {
        return t.dataset.marker === markerId;
      });
      if (targetIndex !== -1) {
        index = targetIndex;
        setActive(index);
      }
    });
  });
  setActive(0);
});

},{}],2:[function(require,module,exports){
"use strict";

require('../app/map-dc');

},{"../app/map-dc":1}]},{},[2]);
